import { render, staticRenderFns } from "./_message_participant.vue?vue&type=template&id=0f457f2e"
import script from "./_message_participant.vue?vue&type=script&lang=js"
export * from "./_message_participant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports